import { render, staticRenderFns } from "./Compatibility.vue?vue&type=template&id=5abb0c2d&"
import script from "./Compatibility.vue?vue&type=script&lang=js&"
export * from "./Compatibility.vue?vue&type=script&lang=js&"
import style0 from "./Compatibility.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports